import { render } from "./LeaveRequestsView.vue?vue&type=template&id=37a3fc79&scoped=true"
import script from "./LeaveRequestsView.vue?vue&type=script&lang=js"
export * from "./LeaveRequestsView.vue?vue&type=script&lang=js"

import "./LeaveRequestsView.vue?vue&type=style&index=0&id=37a3fc79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a3fc79"]])

export default __exports__